import { LANGS, LanguageDetector } from 'i18n/config/LanguageDetector'
import i18next from 'i18next'
import HttpBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import { onceAsync } from 'util/async'

export const initI18next = onceAsync(async (): Promise<unknown> => {
  return i18next
    .use(HttpBackend)
    .use(new LanguageDetector())
    .use(initReactI18next)
    .init({
      ns: ['default'],
      defaultNS: 'default',
      supportedLngs: LANGS,
      backend: { loadPath: `/api/i18n?lng={{lng}}&ns={{ns}}` },
      react: { useSuspense: false },
      maxRetries: 1,
    })
})
